import { FC } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { Handle, Position } from "react-flow-renderer";
import { useDrop } from "react-dnd";
import { AddLeadingZero } from 'src/utils/utils';
import { EMPTY_OUTGOING_MESSAGE_PLACEHOLDER } from "src/config/constants"
import { useStore, connect } from 'src/store/connect';

interface PlaceholderBlockProps {
  id: string;
  data: NodeData;
}

const PlaceholderBlock: FC<PlaceholderBlockProps> = ({ id, data }) => {
  const classes = useStyles();
  const state = useStore();

  const [{}, drop] = useDrop(() => ({
    accept: "block",
    drop: () => ({ id }),
    collect: (monitor) => ({}),
  }));

  return (
    <div className={classes.root} ref={drop} role={"placeholder"}>
      <Handle
        type="target"
        position={Position.Left}
        onConnect={(params) => {}}
        isConnectable={false}
      />
      <div className={`${(!data.highlighted && state.simulationRunning)? classes.opacity : ''}`}>
        {
          data && data.incomingMessage && data.incomingMessage != "" &&
          <div className={classes.optionContainer}>
            <span style={getOptionIndicatorStyle(data?.strokeColor)} />
            <div className={classes.displayFlex}>
              <Typography className={classes.options}>
                {data?.order && AddLeadingZero(data?.order  || 0)}
              </Typography>
              {
                data?.incomingMessage && data?.incomingMessage !== ''? <Typography className={classes.options}>{data?.incomingMessage}</Typography>
                : <Typography className={`${classes.options} ${classes.labelEmpty}`}>{EMPTY_OUTGOING_MESSAGE_PLACEHOLDER}</Typography>
              }
            </div>
          </div>
        }
        <Typography className={classes.label}>Suelta aquí el componente de tu conversación</Typography>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        isConnectable={false}
      />
    </div>
  );
};

const getOptionIndicatorStyle = (strokeColor: string) => {
  return {
    width: "8px",
    height: "38px",
    borderRadius: "2.5px",
    backgroundColor: strokeColor,
  };
};

export default connect(PlaceholderBlock);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "186px",
    padding: "21px 20px 19px 21px",
    borderRadius: "8px",
    boxShadow: "0 2px 24px 0 rgba(0, 0, 0, 0.08)",
    border: "1px dashed #1D262C",
    backgroundColor: "#ffffff",
  },
  opacity: {
    opacity: 0.36,
  },
  label: {
    overflowWrap: "break-word",
    margin: "0 0 0 20px",
    fontFamily: "Poppins",
    fontSize: "14px",
    color: "#1d262c",
  },
  options: {
    margin: "9px 0 9px 17px",
    overflowWrap: "break-word",
    maxWidth: "120px",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 500,
    color: "#1d262c",
  },
  optionContainer: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "9px",
  },
  displayFlex: {
    display: "flex",
  },
  labelEmpty: {
    fontSize: "14px",
    fontWeight: 400,
    color: "#445561"
  },
}));
